import {
  CreatedBy,
  DeliveryStatus,
  ScheduleMode,
} from '../../../../../../views/marketing/push-notifications/Constants';

export default {
  title: 'Campagnes',
  filters: {
    search: 'Rechercher des campagnes...',
  },
  columns: {
    title: 'Titre',
    created_by: 'Créé par',
    schedule_mode: 'Mode de planification',
    scheduled_at: 'Planifié le',
    sent_at: 'Envoyé le',
    status: 'Statut',
    sent: 'Envoyé',
    delivered: 'Livré',
    delivered_rate: 'Taux de livraison',
    clicks: 'Clics',
    click_rate: 'Taux de clics',
    live: 'En direct',
    actions: 'Actions',
  },
  active_status: {
    draft: 'Brouillon',
    active: 'Actif',
  },
  delivery: {
    in_progress: 'En attente de confirmation',
    awaiting: 'En attente de confirmation',
    verified: 'Vérifié {{relative}}',
    next_check_around: 'Prochaine vérification vers {{time}}',
  },
  breakdown: {
    delivered: '{{count}} livré(s)',
    pending: '{{count}} en attente de confirmation',
    failed_title: 'Non livré',
    all_delivered: 'Livré à tous les destinataires.',
    load_error: 'Impossible de charger le détail de livraison.',
    reasons: {
      DeviceNotRegistered: 'Application supprimée ou notifications désactivées (jeton expiré)',
      MessageRateExceeded: 'Temporairement limité par Expo',
      MessageTooBig: 'Charge utile de notification trop volumineuse',
      MismatchSenderId: 'Identifiants push non concordants',
      InvalidCredentials: 'Identifiants push invalides',
      batch_failed: "Échec de l'envoi par lot",
      missing_ticket: 'Aucune confirmation retournée par Expo',
      unknown: 'Erreur de livraison inconnue',
    },
  },
  created_by: {
    [CreatedBy.System]: 'Système',
    [CreatedBy.User]: 'Utilisateur',
  },
  schedule_mode: {
    [ScheduleMode.Instant]: 'Instantané',
    [ScheduleMode.Scheduled]: 'Planifié',
  },
  delivery_status: {
    [DeliveryStatus.Sending]: 'Envoi en cours',
    [DeliveryStatus.Sent]: 'Envoyé',
    [DeliveryStatus.Queued]: "En file d'attente",
    [DeliveryStatus.Failed]: 'Échoué',
  },
  actions: {
    details: 'Détails',
    view_details: 'Voir les détails',
    resend: 'Renvoyer',
    duplicate_edit: 'Dupliquer et modifier',
    delete: 'Supprimer',
    edit: 'Modifier',
    activate: 'Activer',
    deactivate: 'Désactiver',
  },
  success_messages: {
    campaign_updated: 'Campagne mise à jour avec succès',
    campaign_deleted: 'Campagne supprimée avec succès',
  },
  error_messages: {
    failed_to_update_campaign: 'Échec de la mise à jour de la campagne',
    failed_to_load_data: 'Échec du chargement des données',
    failed_to_delete_campaign: 'Échec de la suppression de la campagne',
  },
};
